module.exports = __webpack_public_path__ + "26239a804d81ecae9b6aef86b42d8b49.jpg";